import React, { useEffect, useState } from 'react';
import { List, Button, Modal, Typography, Card, Row, Col, Image } from 'antd';
import { useDispatch } from 'react-redux';
import { getPPTinformationDetails } from '../../redux/about/actionCreator';
const { Title, Text } = Typography;

const ViewPPTList = ({ data, model_id, formData, setFormData }) => {


    const dispatch = useDispatch();

    const handleView = (item) => {
        console.log('View PPT Item:', item);
        dispatch(getPPTinformationDetails({ ppt_id: item.id, model_id: model_id }));
    };

    useEffect(() => {
        if (data && data.length > 0) {
            dispatch(getPPTinformationDetails({ ppt_id: data[0].id, model_id: model_id }));
            setFormData(prevState => {
                const existingIds = prevState.product_viewed || [];
                const uniqueIds = new Set([...existingIds, data[0].id]);

                const modelIds = prevState.model_viewed || [];
                const modelUniqueIds = new Set([...modelIds, model_id]);
                return {
                    ...prevState,
                    product_viewed: Array.from(uniqueIds),
                    model_viewed: Array.from(modelUniqueIds),
                };
            });
        }
    }, [data])



    return (
        <>
            <Card styles={{
                header: {
                    minHeight: "auto", paddingBlock: "6px"
                },
                body:{ display:"flex",alignItems:"center"}
            }}
                style={{height:"100%"}}
                title="New Product">
                <List style={{width:"100%"}} dataSource={data?.slice(0, 1)} renderItem={(item) => (
                    <List.Item style={{ padding: 0 }} actions={[<Button key="view" type="primary" onClick={() => handleView(item)}> View </Button>,]} >
                        {item.rule_name}
                    </List.Item>
                )}
                />
            </Card>
            {/* <Col xxl={12} lg={12} md={24} xs={24}>
                <Card styles={{
                    header: {
                        minHeight: "auto", paddingBlock: "6px"
                    }
                }} title="Old Phone">
                    <List dataSource={data} renderItem={(item) => (
                        <List.Item style={{ padding: 0 }} actions={[<Button key="view" type="primary"> Change </Button>,]} >
                            {item.rule_name}
                        </List.Item>
                    )}
                    />
                </Card>
            </Col> */}
        </>
    )
}

export default ViewPPTList